import { z } from 'zod'
import { isEmpty } from '../util/isEmpty'

export const PhoneSchema = z
  .string()
  .nonempty()
  .refine(
    (value) => {
      if (isEmpty(value) || isEmpty(value.trim())) return false
      // Strip all non-digit characters for validation
      const digits = value.replace(/[^0-9]/g, '')
      // Check if we have 10 digits (US phone number)
      return digits.length === 10
    },
    {
      message: 'Phone number must be 10 digits',
    }
  )
  .transform((value) => {
    // Always return just the digits
    return value.replace(/[^0-9]/g, '')
  })
  .meta({
    title: 'Phone Number',
    description: 'Phone number as 10 digits (formatting will be applied when displayed)',
    example: '1234567890',
  })
export type Phone = z.infer<typeof PhoneSchema>
